import { rectIntersection } from "../../node_modules/@dnd-kit/core/dist/index";

export function sortCollisionsDesc(
  {data: {value: a}},
  {data: {value: b}}
) {
  return b - a;
}

export const gridScheduleOrderCollision = ({
  collisionRect,
  droppableRects,
  droppableContainers,
  active,
}) => {

  if (active.data?.current?.type === 'group') {
    return scheduleOrderGroupCollision({
      collisionRect,
      droppableRects,
      droppableContainers,
      active
    });
  }

  return scheduleOrderItemCollision({
    collisionRect,
    droppableRects,
    droppableContainers,
    active
  });
}

function scheduleOrderGroupCollision({
  collisionRect,
  droppableRects,
  droppableContainers,
  active
}) {
  const collisions = [];

  const groupDroppableContainer = droppableContainers
    .filter(container => container.data?.current?.type === 'group');

  for (const droppableContainer of groupDroppableContainer) {
    const {id} = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const intersectionRatio = rect.top - collisionRect.top;
      collisions.push({
        id,
        data: { droppableContainer, intersectionRatio },
      })
    }
  }

  const groupsBeforeCollision = collisions.filter((collision) => collision.data?.intersectionRatio > 0)
  if (groupsBeforeCollision?.length) {
    return groupsBeforeCollision.sort((a, b) => a.data?.intersectionRatio - b.data?.intersectionRatio);
  }

  return collisions.sort((a, b) => b.data?.intersectionRatio - a.data?.intersectionRatio);
}

function scheduleOrderItemCollision({
  collisionRect,
  droppableRects,
  droppableContainers,
  active
}) {
  const collisions = [];

  const groupDroppableContainer = droppableContainers
    .filter(container => container.data?.current?.type === 'equipment');

  for (const droppableContainer of groupDroppableContainer) {
    const {id} = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const dy = collisionRect.top - rect.top;
      const dx = Math.min(Math.abs(collisionRect.left - rect.left), Math.abs(collisionRect.left - rect.right));
      const position = (collisionRect.left + (collisionRect.width / 2)) < (rect.left + (rect.width / 2))
        ? 'before'
        : 'after'
      if (droppableContainer.data?.current) droppableContainer.data.current.position = position;

      const intersectionRatio = Math.abs(dy) + Math.abs(dx) * 0.05
      collisions.push({
        id,
        data: { droppableContainer, distanceRatio: intersectionRatio, position },
      })
    }
  }

  return collisions.sort((a, b) => a.data?.distanceRatio - b.data?.distanceRatio);
}